import dayjs from "dayjs";
import { Event } from "../../Event";

export class BudgetFollowupEvents extends Event {
    public onLoad = (value: any, setField: any, setState: any, formValues: any) => {
        this.setFieldValue('budget_followup_user', this.userContext.data.user_name);
    }
}